import React from 'react';

import Page from '~/Components/Layout/Page/Page';

const NotFound = () => (
  <Page>
    <h2>Sorry, this page was not found.</h2>
  </Page>
);

export default NotFound;
